<template>
    <v-app id="inspire">
        <v-app-bar app hide-on-scroll class="white" flat>
            <v-app-bar-nav-icon @click="openDrawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="headline text-uppercase" to="/">
                <span>{{ bussines.shortName }}</span>
                <i class="font-weight-light"> & SPA</i>
            </v-toolbar-title>
            <v-spacer />

            <v-menu v-if="bussines.idBussines != 1"
                v-model="notificationMenu"
                :close-on-content-click="false"
                offset-y
                nudge-bottom="8"
                transition="slide-y-transition"
                :max-width="$vuetify.breakpoint.smAndDown ? '100vw' : '420px'"
                :min-width="$vuetify.breakpoint.smAndDown ? '100vw' : '380px'">
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="fetchNotifications" class="mr-1">
                        <v-badge
                            :content="proximasEntregas.length"
                            :value="proximasEntregas.length > 0"
                            color="red"
                            overlap>
                            <v-icon :color="proximasEntregas.length > 0 ? 'orange darken-1' : 'grey darken-1'">
                                {{ proximasEntregas.length > 0 ? 'mdi-bell-ring' : 'mdi-bell-outline' }}
                            </v-icon>
                        </v-badge>
                    </v-btn>
                </template>

                <v-card>
                    <v-card-title class="py-3 px-4 primary">
                        <v-icon left dark small>mdi-truck-delivery</v-icon>
                        <span class="white--text text-subtitle-2">ENTREGAS HOY / MAÑANA</span>
                        <v-spacer />
                        <v-chip x-small dark outlined class="white--text">
                            {{ proximasEntregas.length }} pendientes
                        </v-chip>
                    </v-card-title>

                    <v-divider />

                    <v-list v-if="proximasEntregas.length" dense class="py-0" style="max-height: 360px; overflow-y: auto;">
                        <template v-for="(item, i) in proximasEntregas">
                            <v-list-item :key="item.id" class="px-4 py-1">
                                <v-list-item-avatar size="32" :color="item.check_in === today ? 'orange' : 'blue darken-1'" class="mr-3">
                                    <span class="white--text text-caption font-weight-bold">
                                        {{ item.check_in === today ? 'HOY' : 'MAN' }}
                                    </span>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="text-body-2 font-weight-medium">
                                        <strong>T-{{ item.id }}</strong>
                                        <span class="ml-2 grey--text text--darken-1 text-caption">{{ item.descEstado }}</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text-caption">
                                        <v-icon x-small class="mr-1">mdi-account</v-icon>{{ item.full_name || '—' }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="text-caption">
                                        <v-icon x-small class="mr-1">mdi-map-marker</v-icon>{{ item.direccion || '—' }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="`d-${i}`" v-if="i < proximasEntregas.length - 1" />
                        </template>
                    </v-list>

                    <v-card-text v-else class="text-center py-6 grey--text">
                        <v-icon large class="mb-2 d-block">mdi-check-circle-outline</v-icon>
                        Sin entregas programadas
                    </v-card-text>

                    <v-divider />
                    <v-card-actions class="px-4 py-2">
                        <span class="text-caption grey--text">Actualizado {{ lastFetch }}</span>
                        <v-spacer />
                        <v-btn x-small text color="primary" @click="fetchNotifications" :loading="loadingProximasEntregas">
                            <v-icon x-small left>mdi-refresh</v-icon> Actualizar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>

            <v-chip class="ml-1" outlined color="green" small>
                <v-icon left small>mdi-spa</v-icon>
                {{ versionNameDist }}
            </v-chip>
        </v-app-bar>

        <v-navigation-drawer v-model="drawer" app width="240" dark :mini-variant.sync="mini">
            <v-list>
                <v-list-item class="px-2">
                    <v-list-item-avatar>
                        <v-img src="../assets/logo.jpg"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-title dark> {{ user.nombres }} {{ user.apellidos }}</v-list-item-title>
                    <v-btn icon @click.stop="mini = !mini">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </v-list-item>
                <v-divider></v-divider>
                <v-list nav dense>
                    <v-list-group :prepend-icon="item.icon" :value="key == 0" v-for="(item, key) in listOwnModules" :key="key">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.modules }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-for="(itemChild, keyChild) in item.items" exact-path :to="itemChild.toPath" :key="keyChild" @click="routePath(keyChild)">
                            <v-list-item-content>
                                <v-list-item-title>{{ itemChild.title.toUpperCase() }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </v-list>
            </v-list>

            <template v-slot:append>
                <div class="pa-2">
                    <v-btn block @click="cerrarSesion" color="red" v-if="!mini"> Cerrar Sesión </v-btn>
                </div>
            </template>
        </v-navigation-drawer>

        <v-main class="grey lighten-3">
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-main>

        <v-footer height="48">
            <v-spacer></v-spacer>
            <strong class="caption">
                Powered
                <v-icon color="yellow">mdi-lightbulb-on-outline </v-icon><a href="https://innout.pe">innout.pe</a>
            </strong>
            <v-spacer></v-spacer>
        </v-footer>
    </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { VersionAPP, TokenCookie } from '@/utils/auth'
import { format } from 'date-fns'

export default {
    data: () => ({
        drawer: true,
        mini: true,
        loadingSync: false,
        clipped: true,
        fixed: false,
        miniVariant: false,
        apps: [
            ['Management', 'mdi-account-multiple-outline'],
            ['Settings', 'mdi-cog-outline']
        ],
        cruds: [
            ['Create', 'mdi-plus-outline'],
            ['Read', 'mdi-file-outline'],
            ['Update', 'mdi-update'],
            ['Delete', 'mdi-delete']
        ],
        right: true,
        rightDrawer: false,
        notificationMenu: false,
        lastFetch: '—',
    }),
    computed: {
        ...mapGetters('users', ['optionalRole', 'listOwnModules']),
        ...mapState('users', ['userLogin', 'roles', 'user']),
        ...mapState('bussines', ['bussines']),
        ...mapState('ventas', ['proximasEntregas', 'loadingProximasEntregas']),
        today() {
            return format(new Date(), 'yyyy-MM-dd')
        },
        versionNameDist() {
            return VersionAPP
        },
        ...mapState('sedes', ['version'])
    },
    methods: {
        fetchNotifications() {
            this.$store.dispatch('ventas/fetchProximasEntregas')
            this.lastFetch = format(new Date(), 'HH:mm')
        },
        async sincronizarProductos(p) {
            this.loadingSync = true
            await this.$store.dispatch('redis/syncRedis', {})
            this.loadingSync = false
        },
        openDrawer() {
            this.drawer = !this.drawer
            this.mini = false
        },
        isExclude(item) {
            const x = this.optionalRole.excludeToAssign.filter((y) => y == item)
            return x.length > 0 ? true : false
        },
        ...mapActions({
            SIGN_OUT: 'users/resetToken'
        }),
        async cerrarSesion() {
            this.$store.commit('mainUI/OPEN_MODAL', { state: true, overlay: false, color: 'red', width: '400px', text: 'CERRANDO SESIÓN' })
            await this.SIGN_OUT()
        },
        goRoute(v) {
            this.$router.replace(v)
        },
        closeUser() {
            this.$cookies.remove(TokenCookie)
            this.$store.commit('users/UPDATE_USER', { id: null, idSede: 1 })
            localStorage.clear()
            this.$router.push('/')
            //location.reload()
        },
        async routePath(index) {
            await this.$store.dispatch('reporte/pathRoute', index)
        }
    },
    async created() {
        await this.$store.dispatch('category/getCategory')
        const openModalVenta = this.$route.query.openModalVenta
        await this.$store.dispatch('utilities/getBancos')
        this.fetchNotifications()
        setInterval(() => {
            this.fetchNotifications()
        }, 120000)
    }
}
</script>
<style>
@media only screen and (max-width: 600px) {
    .container {
        padding: 8px !important;
    }
}
</style>
